const signs = [
  'сотрудники проходят много обучения, но непонятно, зачем;',
  'программы одинаковы для всех;',
  'руководители не понимают, как развивать сотрудников после тренинга;',
  'сильные сотрудники не видят перспектив роста;',
  'нет понятного кадрового резерва;',
  'сотрудников необходимо подготовить к новым должностям;',
  'результаты оценки компетенций не превращаются в действия;',
  'обучение не связано с рабочими задачами;',
  'руководители хотят развивать сотрудников, но не знают, с чего начать;',
  'компания быстро растёт;',
  'формируется новая управленческая команда;',
  'необходимо систематизировать развитие ключевых сотрудников.',
];

export default function WhenNeeded() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Когда компании нужен ИПР
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Признаки, что развитие сотрудников недостаточно системное
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-12">
          {signs.map((s, i) => (
            <div key={i} className="flex items-start gap-3 p-4 bg-gray-50 rounded-xl border border-gray-200 hover:border-teal-200 transition-colors">
              <i className="ri-alert-line text-teal-600 mt-0.5 flex-shrink-0"></i>
              <p className="text-sm text-gray-700 leading-relaxed">{s}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button
            onClick={() => scrollTo('contact')}
            className="bg-teal-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Обсудить систему развития сотрудников
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}